import clsx from 'clsx';
import { Outlet } from 'react-router-dom';

import { SidebarProvider } from '@/components/ui/sidebar';

import { AppSidebar } from './app-sidebar';
import { useWxCopilotContext } from './wx-copilot-host/context';

export function Layout() {
  const { isPanelOpen } = useWxCopilotContext();

  return (
    <SidebarProvider>
      <AppSidebar />
      <div
        className={clsx(
          'relative flex flex-1 flex-col overflow-auto',
          isPanelOpen && 'mr-[400px]',
        )}
      >
        <Outlet />
      </div>
    </SidebarProvider>
  );
}
